import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Startseite" },
  { to: "/ueber-uns", label: "Über uns" },
  { to: "/preise", label: "Preise" },
  { to: "/blog", label: "Blog" },
];

export function Brand({ className = "" }) {
  return (
    <Link to="/" data-testid="site-logo" className={`flex items-center gap-2.5 ${className}`}>
      <div className="w-10 h-10 rounded-xl bg-emerald-900 text-white grid place-items-center shrink-0">
        <ShieldCheck className="w-5 h-5" />
      </div>
      <span className="font-display text-lg font-semibold text-emerald-900 tracking-tight">
        LA<span className="text-emerald-600">I</span>zyDocu
      </span>
    </Link>
  );
}

export default function SiteNav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-30 backdrop-blur-md bg-stone-50/80 border-b border-stone-100">
      <nav className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Brand />

        <div className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s|ü/g, (m) => (m === "ü" ? "ue" : "-"))}`}
              className={`text-sm font-medium transition-colors ${isActive(l.to) ? "text-emerald-900" : "text-stone-500 hover:text-emerald-900"}`}>
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <Link to="/login" data-testid="nav-login" className="hidden sm:inline text-sm font-medium text-stone-500 hover:text-emerald-900">Anmelden</Link>
          <Link to="/testzugang" data-testid="nav-register">
            <Button className="h-11 rounded-xl bg-emerald-900 hover:bg-emerald-800 text-white">Testzugang</Button>
          </Link>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)}
            className="md:hidden w-11 h-11 grid place-items-center rounded-xl text-emerald-900 hover:bg-stone-100" aria-label="Menü">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-stone-100 bg-stone-50 px-6 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className={`block px-3 py-3 rounded-xl text-base font-medium ${isActive(l.to) ? "bg-emerald-50 text-emerald-900" : "text-stone-600 hover:bg-stone-100"}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-3 rounded-xl text-base font-medium text-stone-600 hover:bg-stone-100">Anmelden</Link>
        </div>
      )}
    </header>
  );
}
